// extracted by mini-css-extract-plugin
export default {"footer":"ProductsWindow_footer__2hOeW"};